import Vue from "vue";
import api from "@/api/portal-beneficiario";

const createUsuario = params => {
  return Vue.api.post(
    api.createUsuario(),
    {
      nome: params.nome,
      email: params.email,
      emailConfirmation: params.email,
      senha: params.senha || params.senhaCad,
      codigoBeneficiario: params.codigoBeneficiario,
      codigoTitular: params.codigoTitular,
      dataNascimento: params.dataNascimento,
      cpf: params.cpf,
      incapaz: params.incapaz,
      agreement: true,
      recaptcha: params.recaptcha
    },
    {
      headers: {
        "X-Unimed": params.unimed
      }
    }
  );
};

const getAvatar = store => {
  return Vue.api
    .get(api.getAvatar(), {
      responseType: "blob"
    })
    .then(({ data }) => {
      if (data && data.size !== 0) {
        const reader = new window.FileReader();

        reader.onload = () => {
          store.commit("beneficiario/setAvatarUrl", reader.result);
        };
        reader.readAsDataURL(data);
      }
    });
};

const getParametroLogout = unimedId => {
  return Vue.api.get(api.parametroLogout(unimedId)).then(({ data }) => data);
};

const getUrlPrimeiroAcesso = unimedId => {
  return Vue.api
    .get(api.urlPrimeiroAcesso, { params: { unimedId } })
    .then(({ data }) => data);
};

const unimeds = () => {
  return Vue.api
    .get(api.unimeds, { params: { nome: "" } })
    .then(({ data }) => data);
};

const updateAvatar = file => {
  return Vue.api.post(api.updateAvatar(), file);
};

const updatePassword = params => {
  return Vue.api.patch(api.updatePassword(params.usuarioId), {
    codigoBeneficiario: params.codigoBeneficiario,
    dataNascimento: params.dataNascimento,
    senha: params.senha,
    senhaAtual: params.senhaAtual
  });
};

export {
  createUsuario,
  getAvatar,
  getParametroLogout,
  getUrlPrimeiroAcesso,
  unimeds,
  updateAvatar,
  updatePassword
};
